<template>
    <div class="RiskProfileTypeSelectionCard flex flex-col justify-center items-center">
        <div
            class="border border-solid border-eidSecureBlue-25 rounded-lg p-12 mb-2.5 cursor-pointer hover:opacity-75"
            data-test-id="RiskProfileTypeSelectionCard__iconContainer"
            :class="{'RiskProfileTypeSelectionCard__iconContainer--selected bg-eidTrustGreen-10':selected}"
            @click="selectCard"
        >
            <EidIcon
                data-test-id="RiskProfileTypeSelectionCard__icon"
                :icon-src="riskProfileTypeIconSrc"
                :svg-props="{color: typeIconColor, width: '60px', height: '60px'}"
            />
        </div>
        <div class="flex" data-test-id="RiskProfileTypeSelectionCard__title">
            <span data-test-id="RiskProfileTypeSelectionCard__titleText">{{ title }}</span>
            <EidIcon
                v-tooltip="description"
                class="ml-1 text-eidSecureBlue-50"
                data-test-id="RiskProfileTypeSelectionCard__titleTooltipIcon"
                :icon-src="faQuestionCircle"
            />
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';
    import { RiskProfileType } from '@evidentid/tprm-portal-lib/models/decisioning';

    import {
        getRiskProfileTypeIconSrc,
    } from '@/modules/decisioning-criteria/utils/get-risk-profile-type-icon-src/getRiskProfileTypeIconSrc';
    import { tailwindColors } from '@/styles/variables/tailwind-colors/tailwindColors';

    export default defineComponent({
        name: 'RiskProfileTypeSelectionCard',
        components: {
            EidIcon,
        },
        props: {
            title: {
                type: String as PropType<string>,
                default: '',
            },
            type: {
                type: String as PropType<RiskProfileType | null>,
                default: null,
            },
            description: {
                type: String as PropType<string>,
                default: '',
            },
            selected: {
                type: Boolean as PropType<boolean>,
                default: false,
            },
        },
        emits: [ 'input' ],
        data() {
            return {
                faQuestionCircle,
            };
        },
        computed: {
            riskProfileTypeIconSrc(): string {
                return this.type ? getRiskProfileTypeIconSrc(this.type) : '';
            },
            typeIconColor(): string {
                return this.selected
                    ? tailwindColors.eidTrustGreen.DEFAULT
                    : tailwindColors.eidQualityBlack['50'];
            },
        },
        methods: {
            selectCard(): void {
                this.$emit('input', this.type);
            },
        },
    });
</script>
